import SavedSearch from "../../../components/SavedSearch/SavedSearch"

const SavedSearchSellerPage = () =>{
    return <SavedSearch/>
}

export default SavedSearchSellerPage;